
import React from "react";
import { User, Users, FileText } from "lucide-react";
import { CommandItem } from "@/components/ui/command";
import { Badge } from "@/components/ui/badge";
import { Avatar } from "@/components/User/Avatar";
import type { SearchResult } from "@/hooks/useSearch";

interface SearchResultItemProps {
  result: SearchResult;
  onSelect: (result: SearchResult) => void;
}

export function SearchResultItem({ result, onSelect }: SearchResultItemProps) {
  // Use custom icon based on result type
  const getIcon = () => {
    switch (result.type) {
      case "user":
        return <User className="h-4 w-4 text-primary" />;
      case "group":
        return <Users className="h-4 w-4 text-primary" />;
      case "prompt":
        return <FileText className="h-4 w-4 text-primary" />;
      default:
        return (
          <img 
            src="/lovable-uploads/696668bf-afe7-4791-9555-262f2b681308.png"
            alt="PromptSpace Icon"
            className="h-4 w-4"
          />
        );
    }
  };

  return (
    <CommandItem 
      onSelect={() => onSelect(result)}
      className="flex items-center gap-2 px-4 py-2"
    >
      {result.type === "user" ? (
        <Avatar 
          userId={result.id} 
          avatarId={result.avatarId || 1} 
          size="sm" 
          className="mr-1"
        />
      ) : (
        getIcon()
      )}
      
      <div className="flex flex-col flex-1">
        <span className="font-medium">{result.title}</span>
        <span className="text-xs text-muted-foreground truncate max-w-[200px]">
          {result.description}
        </span>
      </div>
      
      {result.category && (
        <Badge variant="outline" className="text-xs">
          {result.category}
        </Badge>
      )}
    </CommandItem>
  );
}
